import DatePicker from 'vue2-datepicker';
import moment from 'moment/moment';
import rentalService from '../../../services/rental';
import mixin from './../../../mixins/mixin';
import Vue from 'vue';
import bookingService from '../../../services/booking';
import formService from "../../../services/form";

export default {
  data() {
    return {
      rentals: [],
      loading: false,
      bookingsChecking: [],
      bookingsCheckout: [],
      bookingsToday: [],
      currentGuests: [],
      lastBookings: [],
      user: {},
      bookingDetails: false,
      bookingItem: [],
      guestItem: [],
      rentalItem: [],
      channelItem: [],
      showBookingActions: false,
      showBookingPrices: false,
      membersForChecking: [],
      membersForCheckout: [],
      bookingUrl: null
    };
  },
  async mounted() {
    const vm = this;
    this.loading = true;
    Vue.filter('getWeekDayFromDate', function (date) {
      return moment(date).format('ddd DD MMMM . YYYY');
    });
    let rentalIds = this.getCheckedRentalIds(this.checkedRentals);
    await this.getCurrentBookings(rentalIds);
    $(".panel-overlay").click(function () {
      vm.closeDetailModal();
    });
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    DatePicker,
    VExportAnalysis: require('components/export-analysis/export-analysis.vue'),
    VManageLocks: require('components/manage-locks/manage-locks.vue'),
  },
  props: {
    'checkedRentals': Object
  },
  mixins: [ mixin ],
  methods: {
    getWeekDayFromDate(date){
      moment.locale('fr', {
        months : this.$t('months'),
        weekdaysShort : this.$t('medWeekDays'),
        monthsShort : this.$t('shortMonths'),
      });
      return moment(date).format('ddd DD MMMM . YYYY');
    },
    async getCurrentBookings(rentalIds = []) {
      await rentalService.getCurrentBookings(this, rentalIds);
    },
    async showDetail (booking , rental) {
      var vm = this;
      this.bookingUrl = this.getBookingUrl(booking, rental);
      vm.bookingDetails = true;
      vm.bookingItem = booking;
      vm.guestItem = booking.guest;
      vm.rentalItem = rental;
      vm.channelItem = booking.channel;
      if (vm.user && vm.user.rights) {
        const rights = Object.values(vm.user.rights);
        const rightExists = rights.find((item) => item.parent_id == vm.bookingItem.rental.user_id);
        vm.showBookingActions = (rightExists && rightExists.booking_actions);
        vm.showBookingPrices = (rightExists && rightExists.booking_prices);
      }

      vm.rentals.map((rental) => {
        if( rental.id === booking.rental_id) {
          if(rental.the_keys_locks && rental.the_keys_locks.length > 0) {
            booking.areLocksConnectedToBookingRental = true;
            vm.bookingItem.rental.the_keys_locks = rental.the_keys_locks;
          } else {
            booking.areLocksConnectedToBookingRental = false;
          }
        }
      });
      $(".panel-overlay").fadeIn();
      $(".ninja-btn,.panel").addClass("active");
      $(".panel-overlay").fadeIn();
      $(".pannel_sec_second").css({ "right": "-350px" });

      await bookingService.getBookingsSelectedDay(this, booking.checking, [], true);
      await bookingService.getBookingsSelectedDay(this, booking.checkout, [], true);
    },
    closeDetailModal () {
      var vm = this;
      $(".ninja-btn, .panel").removeClass("active");
      $(".panel-overlay").fadeOut();
      $(".pannel_sec_second").css({ "right": "-350px"});
      vm.bookingDetails = false;
    },
    onChangeFollowUp() {
      this.bookingItem.first_name = this.bookingItem.guest.first_name;
      this.bookingItem.last_name = this.bookingItem.guest.last_name;
      this.bookingItem.email = this.bookingItem.guest.email;
      this.bookingItem.phone = this.bookingItem.guest.phone;
      bookingService.updateBooking(this.bookingItem, this);
    },
    toBooking(id, tab, isViewBooking = false) {
      this.closeDetailModal();
      if (!isViewBooking) {
        Vue.router.push({
          name: 'bookings.details.tab',
          params: { id, tab },
        });
      }
    },
    getBookingClassName(id, code, done) {
      if(done === 1 && id === 1) {
        return 'confirmed';
      }
      if((id === 1 && code === 12) || id === 3) {
        return 'confirmed';
      } else if(id === 0 && code === 20) {
        return 'refunded';
      } else if(id == 0) {
        return 'cancelled';
      }
      return '';
    },
    getCheckedRentalIds(checkedRentals) {
      let rentalIds = [];
      for (const id in checkedRentals) {
        if (checkedRentals[id] === true) {
          rentalIds.push(parseInt(id));
        }
      }
      return rentalIds;
    },
    async addOrChangeTeamMember(bookingId, memberId, type) {
      const data = {
        bookingId,
        memberId,
        type,
      };
      await bookingService.assignTeamMemberToBooking(this, data, null, type, true);
    },
    changeFormStatus(type, booking) {
      const data = {
        'id': booking.id,
        'welcome_form_submitted': booking.welcome_form_submitted,
        'checkin_form_submitted': booking.checkin_form_submitted,
        type
      };

      formService.changeFormStatus(this, data);
    }
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/analytics/current/current.js